import { createContext, useContext, useState } from "react";

const GameModalContext = createContext();

export const useGameModal = () => useContext(GameModalContext);

export const GameModalProvider = ({ children }) => {
  const [selectedGame, setSelectedGame] = useState(null);

  const openModal = (game) => setSelectedGame(game);
  const closeModal = () => setSelectedGame(null);

  return (
    <GameModalContext.Provider value={{ selectedGame, openModal, closeModal }}>
      {children}
    </GameModalContext.Provider>
  );
};
